<template>
  <div>
    <mdb-modal removeBackdrop centered @close="$store.commit('clearCurrentModal')" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">Reset Your Password</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">Please choose your new password for the following account:</p>
        <p class="mb-4 mt-n3">{{this.options.email}}</p>
        <form v-on:submit.prevent v-on:keyup.enter="submit">
          <div>
            <mdb-input label="New password" type="password" v-model="password" outline />
            <mdb-input label="Retype password" type="password" v-model="password1" outline />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn class="btn btn-isi" @click="submit">Submit</mdb-btn>
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  components: {
    ValidationInfo
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      password: null,
      password1: null,
      validationInfo: ""
    };
  },
  methods: {
    submit() {
      if (!this.password || !this.password1) {
        this.validationInfo = "Please type in your password two times.";
        return;
      }
      if (this.password != this.password1) {
        this.validationInfo = "The entered passwords do not match.";
        return;
      }
      this.validationInfo = "";
      this.$http
        .post("/api/UserAction/ResetPassword", {
          email: this.options.email,
          validationCode: this.options.validation_code,
          newPassword: this.password
        })
        .then(() => {
          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Password reset",
              content: "Your password has been changed."
            }
          });
        })
        .catch(() => {
          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Error",
              content:
                "Your password could not be changed. Please request another password reset mail."
            }
          });
        });
    }
  }
};
</script>
